var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1963 16.7692L2.19629 16.7692C1.93139 16.9899 1.53406 16.8299 1.48316 16.5068L1.47754 1.42112C1.47754 1.4211 1.47754 1.42097 1.47754 1.42094C1.47758 1.17896 1.67376 0.98291 1.91575 0.98291H13.1743C13.4163 0.98291 13.6125 1.1791 13.6125 1.42112V16.4325C13.6125 16.8041 13.1792 17.007 12.8938 16.7692L12.8938 16.7692L7.86511 12.5789L7.54503 12.3122L7.22495 12.5789L2.1963 16.7692Z",
    stroke: "#00CABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveFlag);
export default __webpack_public_path__ + "static/media/save_flag.7949db7c655619e70cac5eb280bf3887.svg";
export { ForwardRef as ReactComponent };